module.exports = __webpack_public_path__ + "img/014.3260008f.jpg";